import React from 'react';
import './SplashPage.css';

const STATUS_VERBS = ['Securing', 'Locking in', 'Ciphering', 'Devaulting', 'Cryptrieving', 'Cipherloading'];
const STATUS_NOUNS = ['codes', 'secrets', 'game', 'puzzle', 'cipher'];

const pickRandom = (list) => list[Math.floor(Math.random() * list.length)];

function SplashPage({ loading, error, darkMode, onRetry, onStart }) {
  // Pick once per mount so it doesn't change every time standbyDots re-renders.
  const [statusMessage] = React.useState(() => `${pickRandom(STATUS_VERBS)} today's ${pickRandom(STATUS_NOUNS)}.`);

  // Animated "Stand by" dots: update every 400ms while loading.
  const [standbyDots, setStandbyDots] = React.useState(0);
  React.useEffect(() => {
    let tid = null;
    if (loading) {
      setStandbyDots(0);
      tid = setInterval(() => {
        setStandbyDots((d) => (d >= 3 ? 1 : d + 1));
      }, 400);
    } else {
      setStandbyDots(0);
    }
    return () => {
      if (tid) clearInterval(tid);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <div className="splash-container">
      <div className="splash-content">
        <img src="/crackle-hex-logo2.png" alt="Crackle Logo" className="splash-logo" />

        <div className="splash-status-area">
          {!error && (
            <div className="splash-status">
              {statusMessage}
              <div className="splash-status-sub">
                {loading ? (
                  <span>
                    Stand by
                    <span
                      style={{ display: 'inline-block', minWidth: '3ch', textAlign: 'left', marginLeft: 4 }}
                      aria-hidden="true"
                    >
                      {'.'.repeat(standbyDots)}
                    </span>
                  </span>
                ) : (
                  "You may begin, good luck."
                )}
              </div>
            </div>
          )}

          {!!error && (
            <div className="splash-error">
              {error}{' '}
              <button onClick={onRetry} className="splash-retry">
                Retry
              </button>
            </div>
          )}
        </div>

        <button
          className="splash-button"
          onClick={(e) => {
            e.stopPropagation();
            onStart();
          }}
          disabled={loading || !!error}
          aria-disabled={loading || !!error}
        >
          Get Cracking
        </button>
      </div>
    </div>
  );
}

export default SplashPage;
